import {ResetParentDataBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/reset-parent-data-behavior';
import {CreateParentNodeChildrenBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/create-parent-node-children-behavior';
import {NeighborhoodHeadNodeBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/neighborhood-head-node-behavior';
import {EndNodeAppender} from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/end-node-appender';
import {ReplaceShapeBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/replace-shape-behavior';
import {CustomTextBehaviour} from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/custom-text-behaviour';
import {ModelerNeighborNodeOverlayBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/modeler-neighbor-node-overlay-behavior';
import {GuideBoxOverlayBehaviour} from '@ispm/shared/bpmn-io/behavior/guide-box-overlay-behaviour';
import {NodeVisibilityBehavior} from '@ispm/shared/bpmn-io/behavior/node-visibility-behavior';
import {DeletedIconOverlayBehavior} from "@ispm/shared/bpmn-io/behavior/deleted-icon-overlay-behavior";
import {NodeOpenNotesButtonOverlayBehavior} from "@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/node-open-notes-button-overlay-behavior";
import {CloseNotesPanelBehavior} from "@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/close-notes-panel-behavior";
import {NodeNotesIconOverlayBehavior} from "@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/node-notes-icon-overlay-behavior";
import {MoveElementsBehavior} from "@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/move-elements-behavior";
import {ActionExecuteBehavior} from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/action-execute-behavior';
import { ElementClickEventBehavior } from "@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/element-click-event-behavior"
import {OverlaysInterceptor} from "@ispm/shared/bpmn-io/behavior/overlays-interceptor";
import {TreatmentPlanOverlayBehaviour} from '@ispm/shared/bpmn-io/behavior/treatment-plan-overlay-behaviour';


export const ModelerInterceptorsExtensionModule = {

  __init__: [
    'resetParentDataBehavior', 'createParentNodeChildrenBehavior',
    'modelerNodeOverlayBehavior', 'guideBoxOverlayBehavior', 'deletedIconOverlayBehavior', 'neighborhoodHeadNodeBehavior', 'replaceShapeBehavior', 'customTextBehaviour',
    'endNodeAppender', 'nodeVisibilityBehavior', 'nodeOpenNotesButtonOverlayBehavior', 'closeNotesPanelBehavior', 'nodeNotesIconOverlayBehavior','moveElementsBehaviour',
    'actionExecuteBehavior','elementClickEventBehavior', 'overlaysInterceptor','treatmentPlanOverlayBehaviour'
  ],
  resetParentDataBehavior: ['type', ResetParentDataBehavior],
  createParentNodeChildrenBehavior: ['type', CreateParentNodeChildrenBehavior],
  modelerNodeOverlayBehavior: ['type', ModelerNeighborNodeOverlayBehavior],
  guideBoxOverlayBehavior: ['type', GuideBoxOverlayBehaviour],
  deletedIconOverlayBehavior: ['type', DeletedIconOverlayBehavior],
  neighborhoodHeadNodeBehavior: ['type', NeighborhoodHeadNodeBehavior],
  replaceShapeBehavior: ['type', ReplaceShapeBehavior],
  customTextBehaviour: ['type', CustomTextBehaviour],
  endNodeAppender: ['type', EndNodeAppender],
  nodeVisibilityBehavior: ['type', NodeVisibilityBehavior],
  nodeOpenNotesButtonOverlayBehavior: ['type', NodeOpenNotesButtonOverlayBehavior],
  closeNotesPanelBehavior: ['type', CloseNotesPanelBehavior],
  nodeNotesIconOverlayBehavior: ['type', NodeNotesIconOverlayBehavior],
  moveElementsBehaviour: ['type', MoveElementsBehavior],
  actionExecuteBehavior: ['type', ActionExecuteBehavior],
  elementClickEventBehavior: ['type', ElementClickEventBehavior],
  overlaysInterceptor: ['type', OverlaysInterceptor],
  treatmentPlanOverlayBehaviour: ['type', TreatmentPlanOverlayBehaviour]
};
